import { CanvasType } from "../../../constants/schema.js";
import { ShowMode, VisualizationMode } from "./state.js";
//#region src/engine/modules/editor/view.ts
var showsFlowTab = (state) => state.settings.canvasType === CanvasType.visualization && state.editor.visualizationMode === VisualizationMode.flow;
var getActiveView = (state) => showsFlowTab(state) ? state.editor.views.flow : null;
var isViewShown = (state, kind) => state.editor.views[kind] !== null && showsFlowTab(state);
var getSourceView = (state, source) => source === "document" ? null : state.editor.views[source];
var isSameCenters = (a, b) => a.length === b.length && a.every((id, index) => id === b[index]);
function toSteppedCenters(tableIds, view, centerIds) {
	const live = centerIds.filter((id) => tableIds.has(id));
	if (centerIds.length && !live.length) return null;
	return isSameCenters(live, view.centerIds) ? null : live;
}
function createSceneView(kind, centerIds = []) {
	const centers = [...centerIds];
	return {
		kind,
		showMode: centers.length ? ShowMode.keysOnly : ShowMode.nameOnly,
		positions: {},
		originX: 0,
		originY: 0,
		zoomLevel: 1,
		centerIds: centers,
		previousCenterIds: [],
		nextCenterIds: []
	};
}
//#endregion
export { createSceneView, getActiveView, getSourceView, isSameCenters, isViewShown, toSteppedCenters };
